import NumberFormatter from "@/service/NumberFormatter";

export default function formatNumber(value: number | string | undefined) {
  return NumberFormatter.format(value as number);
}
